<div class="manage-page-content-dialog">
  <div class="manage-page-content-dialog-header-wrapper">
    <p class="manage-page-content-dialog-title">
      {{ translations.managePageContentDialog.title }}
    </p>
    <p class="manage-page-content-dialog-subtitle">
      {{ translations.managePageContentDialog.subtitle }}
    </p>
  </div>

  <div class="manage-page-content-dialog-content" mat-dialog-content>
    <div
      class="page-section-list"
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
    >
      @for (section of sections(); track section.id) {
        <div class="page-section-item" cdkDrag>
          <!-- Drag handle -->
          <div class="drag-handle" cdkDragHandle>
            <mat-icon class="material-icons-outlined">drag_indicator</mat-icon>
          </div>

          <!-- Section name -->
          <span class="section-name">{{ section.name }}</span>

          <!-- Toggle switch -->
          <mat-slide-toggle
            [checked]="section.enabled"
            (change)="onToggleSection(section)"
            class="section-toggle"
            disableRipple
          />
        </div>
      }
    </div>
  </div>

  <div class="manage-page-content-dialog-actions" mat-dialog-actions>
    <button type="button" mat-button class="set-default-btn" (click)="onSave()">
      {{ translations.managePageContentDialog.setAsDefault }}
    </button>
  </div>
</div>
